class AnnouncementCountdown extends HTMLElement {
  #timer;

  connectedCallback() {
    this.#stop();
    const date = (this.dataset.target || '').trim();
    const hasTimezone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(date);
    const target = new Date(hasTimezone || !date ? date : `${date}Z`).getTime();

    if (Number.isNaN(target)) {
      this.hidden = true;
      this.style.display = 'none';
      return;
    }

    const nodes = Object.fromEntries(
      [...this.querySelectorAll('[data-unit]')].map((node) => [node.dataset.unit, node])
    );
    const update = () => {
      const remaining = Math.max(0, target - Date.now());
      const values = {
        days: Math.floor(remaining / 86400000),
        hours: Math.floor((remaining % 86400000) / 3600000),
        minutes: Math.floor((remaining % 3600000) / 60000),
        seconds: Math.floor((remaining % 60000) / 1000),
      };

      for (const [unit, value] of Object.entries(values)) {
        if (nodes[unit]) nodes[unit].textContent = String(value).padStart(2, '0');
      }

      if (remaining === 0) {
        this.#stop();
        this.textContent = this.dataset.expiredText || 'The drop is live';
      }
    };

    this.#timer = window.setInterval(update, 1000);
    update();
  }

  disconnectedCallback() {
    this.#stop();
  }

  #stop() {
    window.clearInterval(this.#timer);
    this.#timer = undefined;
  }
}

if (!customElements.get('announcement-countdown')) {
  customElements.define('announcement-countdown', AnnouncementCountdown);
}
